'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactDOM = require('react-dom');

var BaseInput = (_temp = _class = function (_React$Component) {
	_inherits(BaseInput, _React$Component);

	function BaseInput(props) {
		_classCallCheck(this, BaseInput);

		var _this = _possibleConstructorReturn(this, (BaseInput.__proto__ || Object.getPrototypeOf(BaseInput)).call(this, props));

		_this.state = {
			val: _this.props.value
		};
		return _this;
	}

	_createClass(BaseInput, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.registerInput();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.unregisterInput();
		}
	}, {
		key: 'registerInput',
		value: function registerInput() {
			if (this.props.esFormField != null) {
				this.props.esFormField.registerInput(this);
			}
		}
	}, {
		key: 'unregisterInput',
		value: function unregisterInput() {
			if (this.props.esFormField != null) {
				this.props.esFormField.unregisterInput(this);
			}
		}
	}, {
		key: 'setVal',
		value: function setVal(val) {
			var _this2 = this;

			_bluebird2.default.resolve(this.setState({ val: val })).then(function () {
				_this2.triggerOnChange(val);
			});
		}
	}, {
		key: 'triggerOnChange',
		value: function triggerOnChange(val) {
			if (this.props.onChange != null) {
				this.props.onChange(val);
			}
		}
	}, {
		key: 'handleOnFocus',
		value: function handleOnFocus(e) {
			this.props.onFocus(e);
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (this.refs.input != null) {
				// console.log("try to focus domnode")
				var node = ReactDOM.findDOMNode(this.refs.input);
				node.focus();
			}
		}
	}]);

	return BaseInput;
}(_react2.default.Component), _class.defaultProps = {
	value: null,
	controlKeys: ["Tab", "Shift", "Control", "ArrowLeft", "ArrowRight", "ArrowDown", "ArrowUp", "Backspace", "Enter", "Delete", "Insert", "Home", "End"],
	onEnter: function onEnter() {},
	onFocus: function onFocus() {},
	className: "",
	bsSize: null,
	disabled: false,
	autoFocus: false,
	inputType: "text",
	size: null,
	maxLength: null
}, _class.propTypes = {
	className: _propTypes2.default.string,
	value: _propTypes2.default.any,
	controlKeys: _propTypes2.default.array,
	onChange: _propTypes2.default.func,
	onEnter: _propTypes2.default.func,
	bsSize: _propTypes2.default.string,
	onFocus: _propTypes2.default.func,
	disabled: _propTypes2.default.bool,
	autoFocus: _propTypes2.default.bool,
	inputType: _propTypes2.default.string,
	size: _propTypes2.default.number,
	maxLength: _propTypes2.default.number
}, _temp);
exports.default = BaseInput;